import { State } from '@q6cyber/proto2es/generated/client';

export const clientFilteredStates = [
  State[State.DELETED],
  State[State.INTERNAL],
];
